"use client"

import { useInView } from "react-intersection-observer"
import { Phone, Mail, MapPin, Facebook } from "lucide-react"
import { Link } from "react-router-dom"
import "../assets/css/footer.css"
import Logo from "../assets/images/logo.jpg"

export default function Footer() {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: true,
  })

  return (
    <footer id="footer" ref={ref} className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className={`footer-column ${inView ? "visible" : ""}`}>
            <h3 className="footer-title">Green Beat Ceylon</h3>
            <p className="footer-tagline">Farming Smarter - Growing Greener</p>
            <p className="footer-text">
              Partner with us for premium quality Scotch Bonnet Dark Green Chilies, grown with care and sustainability
              in mind.
            </p>
          </div>

          <div className={`footer-column ${inView ? "visible" : ""}`} style={{ transitionDelay: "0.2s" }}>
            <h3 className="footer-title">Contact Us</h3>
            <ul className="contact-list">
              <li className="contact-item">
                <Phone className="contact-icon" />
                <span>+94 77 117 2694</span>
              </li>
              <li className="contact-item">
                <Mail className="contact-icon" />
                <span>Info@gbceylon.com</span>
              </li>
              <li className="contact-item">
                <MapPin className="contact-icon" />
                <span>Nikaweratiya , Kurunegala, Sri Lanka, 50300</span>
              </li>
              
            </ul>
          </div>

          <div className={`footer-column ${inView ? "visible" : ""}`} style={{ transitionDelay: "0.4s" }}>
            <h3 className="footer-title">Quick Links</h3>
            <ul className="quick-links">
              {[
                { label: "Products", path: "/#products" },
                { label: "Services", path: "/#services" },
                { label: "About", path: "/#about" },
                { label: "Upcoming", path: "/#upcoming" },
                { label: "Contact", path: "/#contact" },
                { label: "Join Our Team", path: "/careers" }
              ].map((item) => (
                <li key={item.label}>
                  <Link to={item.path} className="quick-link">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className={`footer-column ${inView ? "visible" : ""}`} style={{ transitionDelay: "0.6s" }}>
            <h3 className="footer-title">Contact Us</h3>
            <li className="contact-item">
                <a href="https://www.facebook.com/share/1EHkCYuVX9/" className="social-link" target="_blank" rel="noopener noreferrer">
                  <Facebook className="social-icon" />
                </a>
                <a   href="https://wa.me/+94771172694" className="social-link" target="_blank" rel="noopener noreferrer">
                  {/* add whatsapp */}
                  <img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp" className="social-icon" style={{ width: "24px", height: "24px" }} />
                </a>
            </li>

            <img
              src={Logo}
              alt="Green Beat Ceylon Logo"
              className="footer-logo"
              style={{ maxWidth: "90px", margin: "10px auto", display: "block", borderRadius: "50%" }}
            />
            
          </div> 
        </div>

         <div className="footer-bottom">
         <div className="footer-copyright">
            <p>
                &copy; {new Date().getFullYear()} All rights reserved.
                Developed by{" "}
                <a
                  href="https://www.facebook.com/share/1ANgQS4Qn6/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#4ade80", textDecoration: "underline" }}
                >
                  KoreBit
                </a>
                .
            </p>
          </div>
          
        </div>
      </div>
    </footer>
  )
}
